import { DialogTitle, DialogContent } from '@mui/material';
import React, { useEffect, useRef, useState } from "react";
import "./AccessControlDialog.scss";
import { useForm } from "react-hook-form";
import {
  comparators,
  coreumParameters,
} from "../../utils/config/accessControlConfig";
import axios from 'axios';

interface AccessControlDialogProps {
  setCurrentCondition: any;
  setAccessControlDialog: any;
  currentCondition: any;
}



const CoreumForm: React.FC<AccessControlDialogProps> = ({
  setCurrentCondition,
  setAccessControlDialog,
  currentCondition,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const form = useRef<HTMLFormElement>(null);
  const [currentValue, setCurrentValue] = useState<any>({});
  const [availableDenoms, setAvailableDenoms] = useState<any[]>([]);

  const onSubmit = (data: any) => {
    const submissionData = {...data};
    submissionData['chain'] = 'Coreum_Mainnet'
    submissionData['standardContractType']=""
    submissionData["returnValueTest"] = {
      comparator: submissionData["comparator"],
      value: submissionData["value"],
    };
    delete submissionData["comparator"];
    delete submissionData["value"];
    if ( submissionData.method === "getNftsByAddress") {
      delete submissionData['denom'];
    }else{
      delete submissionData['classid']
    }
    setCurrentCondition(submissionData);
    setAccessControlDialog(false);
  };

  useEffect(() => {
    const subscription = watch((value: any) => {
      setCurrentValue(value);
    });
    return () => subscription.unsubscribe();
  }, [watch]);


  useEffect(() => {
    const fetchDenomMetadata = async () => {
      try {
        const response = await axios.get('https://full-node.mainnet-1.coreum.dev:1317/cosmos/bank/v1beta1/denoms_metadata');
        setAvailableDenoms(response?.data?.metadatas)
      } catch (error) {
        console.error('Error fetching denom metadata:', error);
      }
    };

    fetchDenomMetadata();
  }, []);

  useEffect(() => {
    let componentMounted = true;
    if (currentCondition && availableDenoms.length > 0 && componentMounted) {      
      const resetObject: {
        method: any;
        chain: any;
        standardContractType: any;
        comparator: any;
        value: any;
        denom?: any;
        classid?: any;
      } = {
        method: currentCondition?.method,
        chain: currentCondition?.chain,
        standardContractType: currentCondition?.standardContractType,
        comparator: currentCondition?.returnValueTest?.comparator,
        value: currentCondition?.returnValueTest?.value,
      };
      currentCondition?.method === "getNftsByAddress"
        ? (resetObject.classid = currentCondition?.classid)
        : (resetObject.denom = currentCondition?.denom);
        
      reset(resetObject);
    }
    return () => {
      componentMounted = false;
    };
  }, [availableDenoms]);

  return (
    <div className="AccessControlDialog">
      <DialogTitle>{`Add Access Condition`}</DialogTitle>
      <DialogContent>
        <div className="AccessForm">
          <form ref={form} className="form" onSubmit={handleSubmit(onSubmit)}>
            <div className="fieldContainer">
              <div className="fieldContainer__title">Chain</div>
              <input
                  type="text"
                  placeholder="Chain"
                  disabled={true}
                  value={'Coreum_Mainnet'}
                  {...register("chain", { required: false })}
                />
            </div>
            <div className="fieldContainer">
              <div className="fieldContainer__title">Contract Type</div>
              <input
                  type="text"
                  placeholder="Contract Type"
                  disabled={true}
                  value={'Custom'}
                  {...register("standardContractType", { required: false })}
                />
            </div>

            <div className="fieldContainer">
                <div className="fieldContainer__title">Method</div>
                <select
                  className={errors.method ? "errorInput" : ""}
                  {...register("method", { required: true })}
                >
                  {coreumParameters.methords.map((type, key) => (
                    <option key={key} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
                {errors.method && (
                  <span className="fieldContainer__error">
                    This field is required
                  </span>
                )}
              </div>
       

            <div className="fieldContainer">
            <div className="fieldContainer__title">{currentValue.method === 'getFtsByAddress'? 'Denom' : "Class ID / Contract Address"}</div>   
            {
              currentValue.method === 'getFtsByAddress'? <>
                

<select
                  className={errors.denom ? "errorInput" : ""}
                  {...register("denom", { required: true })}
                >
                  {availableDenoms.map((denomObj, key) => (
                    <option key={key} value={denomObj?.name}>
                      {denomObj?.name}
                    </option>
                  ))}
                </select>
              {errors.denom &&
                errors.denom.type === "required" && (
                  <span className="fieldContainer__error">
                    This field is required
                  </span>
                )}
              </> : <>
              <input
                type="text"
                placeholder={"Class ID"}
                className={errors.classid ? "errorInput" : ""}
                {...register("classid", {
                  required: true,
                })}
              />
              {errors.classid &&
                errors.classid.type === "required" && (
                  <span className="fieldContainer__error">
                    This field is required
                  </span>
                )}
              </>

            }             
           
            </div>

            <div style={{ display: "flex" }}>
              <div style={{ width: "50%", paddingRight: "5px" }}>
                <div className="fieldContainer">
                  <div className="fieldContainer__title">Comparator</div>
                  <select
                    className={errors.comparator ? "errorInput" : ""}
                    {...register("comparator", { required: true })}
                  >
                    {
                      currentValue.method === 'getFtsByAddress' ? <>
                        {comparators.map((type, key) => (
                      <option key={key} value={type}>
                        {type}
                      </option>
                    ))}
                      </>:<>
                      <option>{"=="}</option>
                      </>
                    }
                  </select>
                  {errors.comparator && (
                    <span className="fieldContainer__error">
                      This field is required
                    </span>
                  )}
                </div>
              </div>
              <div style={{ width: "50%", paddingLeft: "5px" }}>
                <div className="fieldContainer">
                  <div className="fieldContainer__title">value</div>
                  {
                    currentValue.method === 'getFtsByAddress' ? <>
                        <input
                    type="number"
                    placeholder="Value"
                    className={errors.value ? "errorInput" : ""}
                    {...register("value", {
                      required: true,
                      pattern: {
                        value: /^(0|[1-9]\d*)(\.\d+)?$/,
                      },
                    } as any)}
                  />
                    </>:<>
                    <select
                    className={errors.value ? "errorInput" : ""}
                    {...register("value", { required: true })}
                  >
                    <option>{1}</option>
                    <option>{0}</option>
                  </select>
                    </>
                  }
                  {errors.value && (
                    <span className="fieldContainer__error">
                      This field is required
                    </span>
                  )}
                </div>
              </div>
            </div>

            <button className="btn ptr" type="submit">
              Create Access Condition
            </button>
          </form>
        </div>
      </DialogContent>
    </div>
  );
};

export default CoreumForm;
